import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PoliticaPrivacidadModal from './PoliticaPrivacidadModal.jsx';
import TerminosCondicionesModal from './TerminosCondicionesModal.jsx';
import logoImg from '../assets/CBR_Logo_Icono.png';

export default function Footer() {
  const [isPrivacyOpen, setPrivacyOpen] = useState(false);
  const [isTermsOpen, setTermsOpen] = useState(false);
  const year = new Date().getFullYear();
  return (
    <footer style={{
      background: 'rgba(8,8,48,0.95)',
      borderTop: '1px solid rgba(184,115,51,0.2)',
      padding: '3rem 0 1.5rem',
      marginTop: 'auto',
      color: 'white',
    }}>
      <div className="container">
        <div className="grid-4" style={{ marginBottom: '2rem' }}>
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1rem' }}>
              <div style={{
                width: 40, height: 40,
                background: 'white',
                borderRadius: '8px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0
              }}>
                <img
                  src={logoImg}
                  alt="Logo CBR"
                  style={{ width: '28px', height: '28px' }}
                />
              </div>
              <div>
                <div style={{ fontFamily: 'Space Grotesk, sans-serif', fontWeight: 700, fontSize: '0.95rem' }}>{import.meta.env.VITE_CBR_NAME || "CBR San Carlos"}</div>
                <div style={{ fontSize: '0.7rem', color: 'var(--copper)', letterSpacing: '0.08em' }}>Ley N° 21.772 — Chile</div>
              </div>
            </div>
            <p style={{ color: 'var(--gray-500)', fontSize: '0.82rem', lineHeight: 1.7 }}>
              Sistema de modernización del Conservador de Bienes Raíces de Chile,
              conforme a la Ley 21.772 vigente a partir del 2 de abril de 2026.
            </p>
          </div>

          {/* Links */}
          <div>
            <h5 style={{ color: 'var(--copper-light)', fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '1rem' }}>Servicios</h5>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {[
                { to: '/', label: 'Búsqueda de Índices' },
                { to: '/tramites', label: 'Portal de Trámites' },
                { to: '/solicitudes', label: 'Solicitar Certificados' },
              ].map(l => (
                <li key={l.label}>
                  <Link to={l.to} style={{ color: 'var(--gray-400)', fontSize: '0.85rem', transition: 'color 0.2s' }}
                    onMouseOver={e => e.target.style.color = 'var(--copper-light)'}
                    onMouseOut={e => e.target.style.color = 'var(--gray-400)'}
                  >{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Links de Interés */}
          <div>
            <h5 style={{ color: 'var(--copper-light)', fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '1rem' }}>Links de Interés</h5>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {[
                { href: 'https://www.sernac.cl/portal/617/w3-channel.html', label: 'SERNAC' },
                { href: 'https://homer.sii.cl/', label: 'SII' },
                { href: 'https://tgr.gob.cl/', label: 'Tesorería' },
                { href: 'https://www.registrocivil.cl/', label: 'Registro Civil' },
              ].map(l => (
                <li key={l.label}>
                  <a href={l.href} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--gray-400)', fontSize: '0.85rem', transition: 'color 0.2s', textDecoration: 'none' }}
                    onMouseOver={e => { e.currentTarget.style.color = 'var(--copper-light)'; e.currentTarget.style.textDecoration = 'underline'; e.currentTarget.style.textUnderlineOffset = '4px'; }}
                    onMouseOut={e => { e.currentTarget.style.color = 'var(--gray-400)'; e.currentTarget.style.textDecoration = 'none'; }}
                  >
                    {l.label} <span style={{fontSize: '0.7rem', verticalAlign: 'middle'}}>↗</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h5 style={{ color: 'var(--copper-light)', fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '1rem' }}>Marco Legal</h5>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {[
                { label: 'Ley N° 21.772', href: 'https://www.bcn.cl/leychile/navegar?idNorma=1217156', isExternal: true },
                { label: 'Aranceles Decreto Exento N°588-1998', href: 'https://www.bcn.cl/leychile/navegar?idNorma=127921', isExternal: true },
                { label: 'Política de Privacidad', href: '#', isExternal: false, onClick: (e) => { e.preventDefault(); setPrivacyOpen(true); } },
                { label: 'Términos de Uso', href: '#', isExternal: false, onClick: (e) => { e.preventDefault(); setTermsOpen(true); } },
              ].map(t => (
                <li key={t.label} style={{ fontSize: '0.83rem' }}>
                  {t.isExternal ? (
                    <a href={t.href} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--gray-500)', textDecoration: 'none', transition: 'all 0.2s' }}
                      onMouseOver={e => { e.currentTarget.style.color = 'var(--copper-light)'; e.currentTarget.style.textDecoration = 'underline'; e.currentTarget.style.textUnderlineOffset = '4px'; }}
                      onMouseOut={e => { e.currentTarget.style.color = 'var(--gray-500)'; e.currentTarget.style.textDecoration = 'none'; }}
                    >
                      {t.label} <span style={{fontSize: '0.7rem', verticalAlign: 'middle'}}>↗</span>
                    </a>
                  ) : t.onClick ? (
                    <a href={t.href} onClick={t.onClick} style={{ color: 'var(--gray-500)', textDecoration: 'none', transition: 'all 0.2s', cursor: 'pointer' }}
                      onMouseOver={e => { e.currentTarget.style.color = 'var(--copper-light)'; e.currentTarget.style.textDecoration = 'underline'; e.currentTarget.style.textUnderlineOffset = '4px'; }}
                      onMouseOut={e => { e.currentTarget.style.color = 'var(--gray-500)'; e.currentTarget.style.textDecoration = 'none'; }}
                    >
                      {t.label}
                    </a>
                  ) : (
                    <span style={{ color: 'var(--gray-500)' }}>{t.label}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.06)',
          paddingTop: '1.2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '0.5rem',
        }}>
          <p style={{ color: 'var(--gray-600)', fontSize: '0.78rem' }}>
            © {year}  PrismAgen · Todos los derechos reservados
          </p>
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            <span style={{ color: 'var(--gray-600)', fontSize: '0.75rem' }}>🔒 Cifrado AES-256</span>
            <span style={{ color: 'var(--gray-600)', fontSize: '0.75rem' }}>🇨🇱 Hecho en Chile</span>
          </div>
        </div>
      </div>
      {isPrivacyOpen && <PoliticaPrivacidadModal onClose={() => setPrivacyOpen(false)} />}
      {isTermsOpen && <TerminosCondicionesModal onClose={() => setTermsOpen(false)} />}
    </footer>
  );
}
